app.controller('FinancialsInvoiceCtrl', ['$rootScope', '$routeParams', function($rootScope, $routeParams) {

  var self = this;
  self.supplierId = $rootScope.selectedSupplier.id;

  var path = '/api/supplier/' + self.supplierId + '/invoice/' + $routeParams.orderItemId + '/pdf';
  window.location.href = path;
}]);
